export const checkStartsWithArray =
  (substrings: string[]) =>
  (s?: string): boolean => {
    if (!s) return false;
    return substrings.some((substring) => s.startsWith(substring));
  };

export const isSection232 = checkStartsWithArray(['SECTION_232', 'section232']);
export const isSection301 = checkStartsWithArray(['SECTION_301', 'section301']);
